import { useMemo } from 'react';
import { Button, Menu, Text } from '@mantine/core';
import { IconRubberStamp } from '@tabler/icons-react';
import { useRegulatoryClauses } from '../modules/procurementConfig/hooks/useProcurementConfig';
import { dhivehiDisplayStyle } from '../utils/dhivehiText';

function formatClauseInsert(title: string, description: string): string {
  const block = `${title}\n${description}`;
  return `\n\n${block}`;
}

type RegulatoryClausePickerProps = {
  onInsert: (text: string) => void;
  disabled?: boolean;
};

export function RegulatoryClausePicker({ onInsert, disabled }: RegulatoryClausePickerProps) {
  const { data: clauses = [], isLoading } = useRegulatoryClauses(false);

  const activeClauses = useMemo(
    () => clauses.filter((c) => c.isActive).sort((a, b) => a.sortOrder - b.sortOrder),
    [clauses]
  );

  if (isLoading || activeClauses.length === 0) {
    return null;
  }

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <Button
          type="button"
          variant="subtle"
          size="compact-xs"
          leftSection={<IconRubberStamp size={14} />}
          disabled={disabled}
        >
          Insert regulatory clause
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {activeClauses.map((clause) => (
          <Menu.Item
            key={clause.id}
            onClick={() => onInsert(formatClauseInsert(clause.title, clause.description))}
          >
            <Text size="sm" style={dhivehiDisplayStyle(clause.title)}>
              {clause.title}
            </Text>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
